{
  "app": {
    "shellTitle": "Dink Product Admin · Console Plateforme",
    "loading": "Chargement"
  },
  "common": {
    "retry": "Réessayer",
    "close": "Fermer",
    "menu": "Menu",
    "loading": "Chargement",
    "language": "Langue",
    "comingSoon": "Bientôt disponible",
    "noProgress": "Aucune progression"
  },
  "lang": { "en": "EN", "es": "ES", "fr": "FR", "pt": "PT" },
  "language_switcher": {
    "label": "Langue",
    "options": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português"
    }
  },
  "nav": {
    "signOut": "Se déconnecter",
    "signIn": "Se connecter",
    "group": { "operations": "Opérations", "configuration": "Configuration" },
    "dashboard": "Tableau de bord",
    "queue": "File d'attente",
    "notifications": "Notifications",
    "logs": "Journaux",
    "tenants": "Locataires",
    "engine": "Moteur",
    "globalConfig": "Configuration globale"
  },
  "shell": {
    "scope": "Plateforme — tous les locataires",
    "notificationsAriaLabel": "Notifications",
    "accountMenu": "Compte"
  },
  "page": {
    "dashboard": { "title": "Tableau de bord" },
    "queue": { "title": "File d'attente" },
    "notifications": { "title": "Notifications" },
    "logs": { "title": "Journaux" },
    "tenants": { "title": "Locataires" },
    "engine": { "title": "Moteur" },
    "globalConfig": { "title": "Configuration globale" }
  },
  "bootstrap": {
    "error": "Impossible de charger la configuration de l'application.",
    "errorNotRegistered": "Cet hôte n'est pas enregistré. Contactez votre administrateur.",
    "retry": "Réessayer"
  },
  "auth": {
    "redirecting": "Redirection vers la connexion…",
    "returning": "Finalisation de la connexion…",
    "noAccessTitle": "Vous n'avez pas accès à cette console",
    "noAccessBody": "Votre compte est connecté, mais l'accès à cette console d'administration du produit ne lui a pas été accordé. Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur.",
    "productAdminRequired": "Accès administrateur du produit requis",
    "productAdminRequiredBody": "Vous êtes connecté, mais l'accès à cette console d'administration du produit n'a pas été accordé à votre compte.",
    "signedOutTitle": "Vous êtes déconnecté",
    "signedOutBody": "Votre session d'administrateur du produit a pris fin.",
    "signInAgain": "Se connecter à nouveau"
  },
  "errors": {
    "generic": "Quelque chose s'est mal passé. Veuillez réessayer.",
    "network": "Erreur réseau. Vérifiez votre connexion et réessayez.",
    "notFoundTitle": "Introuvable",
    "notFoundBody": "Nous n'avons pas trouvé ce que vous cherchiez."
  },
  "help": {
    "ariaLabel": "Aide pour {{label}}"
  }
}
